/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  // Clean up any stale or corrupted service worker registrations before registering
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    const expectedScope = window.location.origin + process.env.BASE_URL;
    const expectedScript = `${process.env.BASE_URL}service-worker.js`;

    registrations.forEach((registration) => {
      // Check if registration is corrupted (no active worker) or has wrong scope
      const isCorrupted = !registration.active && !registration.installing && !registration.waiting;
      const isWrongScope = registration.scope !== expectedScope && registration.scope !== expectedScope + '/';

      if (isCorrupted || isWrongScope) {
        console.log('Cleaning up stale/corrupted service worker:', registration.scope);
        registration.unregister();
      }
    });
  }).catch((error) => {
    console.error('Error cleaning up service workers:', error);
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      // Check for updates every 30 seconds
      setInterval(() => {
        registration.update();
      }, 30000);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; please refresh.");
      // Dispatch a custom event with the registration to notify the PWA updater component
      document.dispatchEvent(
        new CustomEvent("serviceWorkerUpdateEvent", { detail: registration })
      );
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
  
  // Listen for messages from the service worker
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "SKIP_WAITING") {
      window.location.reload();
    }
  });
}
